<!-- TODO USE CSS GRID TO PLACE THE BLOCKS IN DYNAMIC -->
<!--
  //TODO FOR DYNAMIC ARRANGING OF THE SECTIONS

  <div *ngFor="let divNumber of displayOrder">
  <ng-container *ngIf="divNumber === 1">Div 1</ng-container>
  <ng-container *ngIf="divNumber === 2">Div 2</ng-container>
  <ng-container *ngIf="divNumber === 3">Div 3</ng-container>
  <ng-container *ngIf="divNumber === 4">Div 4</ng-container>
</div> -->

<ng-container
  *ngIf="
    locationBlock ||
      productBlock ||
      customerBlock ||
      userBlock ||
      dateBlock ||
      searchBlock;
    else noBlocks
  "
>
  <div class="col-12">
    <div class="grid justify-content-center">
      <div class="col-12 md:col-12 mb-0">
        <div class="flex align-items-center justify-content-end">
          <button
            (click)="getDefinitionDetails()"
            *ngIf="!searched || searching || !confirmSearch"
            [disabled]="searching"
            [icon]="searching ? 'pi pi-spin pi-spinner' : 'pi pi-search'"
            [label]="searching ? 'Searching...' : 'Search'"
            pButton
            type="button"
          ></button>

          <button
            (click)="alert = true"
            *ngIf="searched && !searching && confirmSearch"
            class="p-button-outlined"
            icon="pi pi-search"
            label="New Search"
            pButton
            type="button"
          ></button>
        </div>
      </div>

      <div *ngIf="searchBlock" class="col-12 md:col-12 mb-0">
        <div class="flex align-items-center">
          <ng-container>
            <div class="field grid">
              <div class="p-input-icon-left mr-3 mb-3">
                <i
                  *ngIf="resultsLoaded; else searching"
                  class="pi pi-search"
                ></i>
                <ng-template #searching>
                  <i class="pi pi-spin pi-spinner"></i>
                </ng-template>
                <!-- Change this icon to a loader when we are searching -->
                <input
                  [(ngModel)]="searchQuery"
                  [placeholder]="searchBlock?.placeHolder || 'Search'"
                  pInputText
                  type="text"
                />
              </div>
            </div>

            <hr />
          </ng-container>
        </div>
      </div>

      <div class="col-12 md:col-12 mb-0">
        <div class="grid justify-content-center">
          <div *ngIf="locationBlock" class="col" id="location-section">
            <h5
              [ngClass]="{ 'no-filter': !locationBlock?.definition }"
              class="flex align-items-center justify-content-between mb-1"
            >
              {{ locationBlock.title ? locationBlock.title : 'Location' }}
              <button
                (click)="showLocationDefinitions = !showLocationDefinitions"
                *ngIf="locationBlock?.definition"
                class="p-button-rounded p-button-text p-2"
                hideDelay="330"
                icon="material-icons-round mi-filter-alt"
                iconPos="right"
                pButton
                pRipple
                pTooltip="Filter using Groupings"
                showDelay="660"
                tooltipPosition="top"
                type="button"
              ></button>
            </h5>

            <boma-location-search
              (locationSelectedChange)="locationHandler($event)"
              [showLabel]="showLabels"
            ></boma-location-search>

            <ng-container *ngIf="locationBlock?.definition">
              <boma-definition-selector
                (selectedItem)="handleSelectedDefinitions($event, 4)"
                *ngIf="showLocationDefinitions"
                [selectedTarget]="4"
                [showLabels]="showLabels"
                [showMenu]="false"
              >
              </boma-definition-selector>
            </ng-container>
          </div>

          <div *ngIf="customerBlock" class="col" id="customer-section">
            <h5
              [ngClass]="{ 'no-filter': !customerBlock?.definition }"
              class="flex align-items-center justify-content-between mb-1"
            >
              Customer
              <button
                (click)="showCustomerDefinitions = !showCustomerDefinitions"
                *ngIf="customerBlock?.definition"
                class="p-button-rounded p-button-text p-2"
                hideDelay="330"
                hideDelay="330"
                icon="material-icons-round mi-filter-alt"
                iconPos="right"
                pButton
                pRipple
                pTooltip="Filter using Groupings"
                showDelay="660"
                showDelay="660"
                tooltipPosition="top"
                tooltipPosition="top"
                type="button"
              ></button>
            </h5>
            <boma-customer-selector
              (selectedItemsChange)="handleSelectedCustomers($event)"
              [placeHolderText]="customerBlock?.searchPlaceholder"
              [showLabels]="showLabels"
              [singleSelection]="customerBlock?.options?.singleSelection"
            ></boma-customer-selector>

            <ng-container *ngIf="customerBlock?.definition">
              <ng-container *ngIf="showCustomerDefinitions">
                <p
                  *ngIf="customerBlock?.options?.locationCheckBox"
                  class="flex align-items-center justify-content-between mt-1"
                >
                  Include Customer Location
                  <p-checkbox
                    [(ngModel)]="customerLocations"
                    [binary]="true"
                  ></p-checkbox>
                </p>

                <boma-definition-selector
                  (selectedItem)="handleSelectedDefinitions($event, 1)"
                  [selectedTarget]="1"
                  [showLabels]="showLabels"
                  [showMenu]="false"
                >
                </boma-definition-selector>
              </ng-container>
            </ng-container>
          </div>

          <div *ngIf="productBlock" class="col" id="product-section">
            <h5
              [ngClass]="{ 'no-filter': !productBlock?.definition }"
              class="flex align-items-center justify-content-between mb-1"
            >
              Product
              <button
                (click)="showProductDefinitions = !showProductDefinitions"
                *ngIf="productBlock?.definition"
                class="p-button-rounded p-button-text p-2"
                hideDelay="330"
                icon="material-icons-round mi-filter-alt"
                iconPos="right"
                pButton
                pRipple
                pTooltip="Filter using Groupings"
                showDelay="660"
                tooltipPosition="top"
                type="button"
              ></button>
            </h5>

            <boma-product-selector
              (selectedProductsChange)="handleProductsSelection($event)"
              [organisation]="currentOrganization"
              id="productSelect"
            ></boma-product-selector>

            <ng-container *ngIf="productBlock?.definition">
              <boma-definition-selector
                (selectBrands)="handleSelectedBrands($event)"
                (selectCategories)="handleSelectedCategories($event)"
                (selectDepartments)="handleSelectedDepartments($event)"
                (selectedItem)="handleSelectedDefinitions($event, 2)"
                *ngIf="showProductDefinitions"
                [selectedTarget]="2"
                [showLabels]="showLabels"
                [showMenu]="false"
              >
              </boma-definition-selector>
            </ng-container>
          </div>

          <div *ngIf="userBlock" class="col" id="users-section">
            <h5 class="no-filter">Users</h5>

            <boma-search-entity-users
              (sendSelectedUser)="handleSelectedUser($event)"
              [entityId]="currentOrganization.id"
              [showLabels]="false"
              [simpleDropDown]="false"
            ></boma-search-entity-users>
          </div>

          <div *ngIf="dateBlock" class="col-12" id="date-section">
            <h5 class="mb-1">Date Range</h5>
            <boma-location-date-range-selector
              (datesSelected)="handleSelectedDate($event)"
              [emitDateImmediately]="true"
              [locationRequired]="false"
              [showLabels]="showLabels"
              [singleDay]="dateBlock.singleDay"
              [shortcutDate]="dateBlock.shortcut"
            >
            </boma-location-date-range-selector>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!--<div class='grid'>-->
<!--  <div class='p-col'>Categories {{this.selectedCategories |json}}</div>-->
<!--  <div class='p-col'>Brands {{this.selectedBrands |json}}</div>-->
<!--  <div class='p-col'>Departments {{this.selectedDepartments |json}}</div>-->
<!--</div>-->

<ng-template #noBlocks>
  <p-messages severity="error">
    <ng-template pTemplate> Search Requires Setup </ng-template>
  </p-messages>
</ng-template>

<p-toast></p-toast>

<p-dialog
  (onHide)="alert = false"
  [(visible)]="alert"
  [modal]="true"
  [style]="{ width: '50vw' }"
  header="Hold on"
>
  <ng-template pTemplate="content">
    {{ confirmation }}
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex align-items-center justify-content-between">
      <div *ngIf="customActions">
        <ng-container *ngFor="let action of customActions">
          <button
            (click)="alertAction(action.action)"
            [class]="action.class"
            [icon]="action.icon"
            [label]="action.label"
            pButton
            type="button"
          ></button>
        </ng-container>
      </div>

      <div>
        <button
          (click)="alertAccept()"
          class="p-button-danger p-button-outlined"
          icon="pi pi-check"
          label="Yes, discard and search again."
          pButton
          type="button"
        ></button>
        <button
          (click)="alertReject()"
          class="p-button-success p-button-outlined"
          icon="pi pi-times"
          label="No, I want to keep editing."
          pButton
          type="button"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!--<p>brands</p>-->
<!--{{selectedBrands | json}}-->
<!--<p>departments</p>-->
<!--{{selectedDepartments | json}}-->
<!--<p>categories</p>-->
<!--{{selectedCategories | json}}-->
